import React, { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Alert,
} from "@mui/material";
import StudyDropDown from "../../../common/components/StudyDropDown";
import CheckEmail from "../../../common/components/CheckEmail";
import { useCreateTAQuery } from "../../../api/useCreateTA";

const TADialog = ({ isModalOpen, closeModal }) => {
  const [emailConfirmed, setEmailConfirmed] = useState(false);
  const [selectedStudy, setSelectedStudy] = useState("");
  const [user, setUser] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const queryClient = useQueryClient();
  const { mutate, isPending, isError, error } = useCreateTAQuery();
  const handleStudyChange = (event) => {
    setSelectedStudy(event.target.value);
  };

  const handleAddTA = async () => {
    if (user && selectedStudy) {
      mutate(
        { studyId: [selectedStudy._id], userId: user._id },
        {
          onSuccess: () => {
            closeModal(); // 성공 시 모달 닫기
            queryClient.invalidateQueries("users");
          },
          onError: (error) => {
            setErrorMessage(
              error.response.data.error || "등록에 실패했습니다."
            ); // 실패 시 에러 메시지 설정
          },
        }
      );
    } else {
      setErrorMessage("유저 또는 스터디를 선택해주세요");
    }
  };
  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>TA 추가</DialogTitle>
      <DialogContent>
        {/* 에러 메시지가 있을 경우 Alert 컴포넌트로 표시 */}
        {isError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}
        <FormControl fullWidth margin="normal">
          <CheckEmail
            emailConfirmed={emailConfirmed}
            setEmailConfirmed={setEmailConfirmed}
            setUser={setUser}
            user={user}
          />
          <StudyDropDown
            selectedStudy={selectedStudy}
            handleStudyChange={handleStudyChange}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} disabled={isPending}>
          취소
        </Button>
        <Button onClick={handleAddTA} disabled={isPending}>
          추가
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TADialog;
